export const SetCookie = (name, value, days, secure = true, sameSite = 'Lax') => {
    let attributes = "; path=/";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        attributes += "; expires=" + date.toUTCString();
    }
    if (secure) {
        attributes += "; Secure";
    }
    attributes += `; SameSite=${sameSite}`;
    document.cookie = name + "=" + (value || "") + attributes;
};
export const GetCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0)
            return c.substring(nameEQ.length, c.length);
    }
    return null;
};
export const EraseCookie = (name) => {
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
};
export const HasGdprConsent = (purpose) => {
    const consentCookieValue = GetCookie("FlowliConsentCookie");
    if (!consentCookieValue) {
        return false;
    }
    const purposes = consentCookieValue.split(",");
    return purposes.indexOf(purpose) != -1;
};
//# sourceMappingURL=CookieUtil.js.map